<template>
  <div>
    <div class="code">
      <div v-for="(item, index) in codeId" :key="index" :class="['code-box', code[index]?'code-boxs':'']">
        <input :id="item" v-model="code[index]" ref="focus" type="number"/>
      </div>
    </div>
    <div v-if="second != 0" class="tip">重新获取（{{ second }}秒）</div>
    <div v-else class="tip tip2" @click="setCode">重新获取</div>
  </div>
</template>

<script>
export default {
  name: 'SmsCode',
  data() {
    return {
      second: 59,
      smsCode: '',
      code: new Array(6),
      codeId: ['first', 'second', 'third', 'forth', 'fifth', 'sixth']
    }
  },
  watch: {
    second(val) {
      if (val === 0) {
        clearInterval(this.timer)
      }
    },
    smsCode(val) {
      if (val.length === 6) {
        this.$emit('get-code', val)
      }
    },
    code: function (newValue, oldValue) {
      let tempValue = ''
      for (let i = 0; i < newValue.length; i++) {
        if (i === 6) {
          console.log(i)
          break
        }
        if (newValue[i]) {
          tempValue = tempValue + newValue[i]
        }
      }
      this.smsCode = tempValue
      let m = tempValue.split("")
      let location = 0
      for (let i = 0; i < newValue.length; i++) {
        if (m[i] && i < 6) {
          location++
          newValue[i] = m[i]
        } else {
          newValue[i] = ''
        }
      }
      // console.log(this.codeId[i])
      if (location < 1) {
        location = 1
      } else if (location > 6) {
        location = 6
      }
      document.getElementById(this.codeId[location - 1]).focus()
    }
  },
  created() {
    //this.setTime()
  },
  methods: {
    // end(e) { //input获取光标显示在最后
    //   console.log('end => e ', e.srcElement.value)
    //   let obj = e.srcElement;
    //   const len = obj.value.length;
    //   console.log('end => obj ', obj.value, obj.value.length, obj.selectionStart, obj.selectionEnd)
    //   //光标定位要加上 setTimeOut，不然就会重新光标定位失败
    //   this.$nextTick(() => {
    //     obj.selectionStart = len+1
    //     obj.selectionEnd = len+1
    //   })
    // },
    setCode() {
      this.$emit('send-code')
    },
    setTime() {
      this.timer = setInterval(() => {
        this.second--
      }, 1000)
    }
  }
}
</script>

<style lang="less" scoped>
.code {
  display: flex;
}
.code .code-box {
  display: block;
  flex: 1;
  border-bottom: 1px solid #C2C0C0;
  margin: 0 5px;
  padding: 5px 0;
}
.code .code-boxs {
  border-bottom: 1px solid #2660CE;
}
.code .code-box input {
  width: 100%;
  border: none;
  text-align: center;
  font-size: 24px;
  font-weight: 800;
}
.tip {
  font-size: 14px;
  color: #C2C0C0;
  padding-top: 5px;
  padding-left: 5px;
}
.tip2 {
  color: #2660CE;
}
</style>



// WEBPACK FOOTER //
// src/modules/SmsCode/index.vue